const key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6,
};

const webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
    '-webkit-full-screen',
];

const moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror',
    '-moz-full-screen',
];

const ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError',
    '-ms-fullscreen',
];

const documentRef =
    typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};

const vendor =
    ('fullscreenEnabled' in documentRef && Object.keys(key)) ||
    (webkit[0] in documentRef && webkit) ||
    (moz[0] in documentRef && moz) ||
    (ms[0] in documentRef && ms) ||
    [];

export default {
    requestFullscreen: (element) => element[vendor[key.requestFullscreen]](),
    requestFullscreenFunction: (element) => element[vendor[key.requestFullscreen]],
    get exitFullscreen() {
        return documentRef[vendor[key.exitFullscreen]].bind(documentRef);
    },
    get fullscreenPseudoClass() {
        return `:${vendor[key.fullscreen]}`;
    },
    addEventListener: (type, handler, options) =>
        documentRef.addEventListener(vendor[key[type]], handler, options),
    removeEventListener: (type, handler, options) =>
        documentRef.removeEventListener(vendor[key[type]], handler, options),
    get fullscreenEnabled() {
        return Boolean(documentRef[vendor[key.fullscreenEnabled]]);
    },
    set fullscreenEnabled(val) {},
    get fullscreenElement() {
        return documentRef[vendor[key.fullscreenElement]];
    },
    set fullscreenElement(val) {},
    get onfullscreenchange() {
        return documentRef[`on${vendor[key.fullscreenchange]}`.toLowerCase()];
    },
    set onfullscreenchange(handler) {
        documentRef[`on${vendor[key.fullscreenchange]}`.toLowerCase()] = handler;
    },
    get onfullscreenerror() {
        return documentRef[`on${vendor[key.fullscreenerror]}`.toLowerCase()];
    },
    set onfullscreenerror(handler) {
        documentRef[`on${vendor[key.fullscreenerror]}`.toLowerCase()] = handler;
    },
};
